import {sendLog} from "../common/SendLog";

//Продолжить (Перенаправление на Госуслуги)
export const nextStep = (serverApi, title, setEsiaUrl, docSessionCode, navigate, appDebag, appLogicType) => {
    setEsiaUrl(true);

    //Формирование ссылки ЕСИА и перенаправление на форму авторизации
    serverApi.getEsiaLink(docSessionCode, appDebag, appLogicType).then((response) => {
        sendLog(serverApi, title,'Формирование ссылки ЕСИА и перенаправление на форму авторизации.', '', false, response);

        // console.log(response)

        // if (response.data.success) {

        const url = response?.data?.url;
        if (!url || url.includes('undefined')) {
            sendLog(serverApi, title, 'Получена некорректная ссылка ЕСИА (содержит undefined).', '', true, { url, response: response?.data });
            navigate('/', {
                state: { error: ['Не удалось получить ссылку ЕСИА'] },
            });
            return;
        }
        window.location.replace(url);

        //window.location.replace(response.data.url);

        // } else {
        //     // navigate('/');
        //     // const errorData = response?.data?.error;
        //
        //     const errorData = response?.data?.error;
        //     navigate('/', {
        //         state: { error: errorData || ['Не удалось получить ссылку ЕСИА'] },
        //     });
        // }
    }).catch((error) => {
        sendLog(serverApi, title, 'Формирование ссылки ЕСИА и перенаправление на форму авторизации.', '', true, error);
        navigate('/', {
            state: { error: ['Ошибка соединения', 'Попробуйте позже'] },
        });
    });
};

